var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"graph",staticClass:"area-graph show-labels"},[_c('div',{ref:"block",staticClass:"block",style:(_vm.style)},[_c('label',{staticClass:"tx-page-subtitle tx-wg-bold"},[_vm._v(_vm._s(_vm.item.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }